import { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import Footer from './Footer';

function Layout() {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <nav className="site-nav">
        <Link className="brand" to="/" onClick={() => setOpen(false)}>
          Gorty's Tech, LLC
        </Link>
        <button
          type="button"
          className="nav-toggle"
          aria-expanded={open}
          aria-label="Open navigation menu"
          onClick={() => setOpen((value) => !value)}
        >
          Menu
        </button>
        <ul className={open ? 'open' : undefined}>
          <li>
            <Link to="/" onClick={() => setOpen(false)}>
              Home
            </Link>
          </li>
          <li>
            <Link className="nav-register" to="/request-services" onClick={() => setOpen(false)}>
              Request Services
            </Link>
          </li>
        </ul>
      </nav>
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
